export const BREAKPOINTS = {
  xl: 1920,
  l: 1440,
  m: 1280,
  s: 768,
  xs: 380,
  xxs: 320
} as const;
